<div mat-dialog-title style="position: relative;">
  <div class="col-12 pr-0 d-flex justify-content-center">
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#FDE6EB"/>
      <path d="M24 20V24M24 28H24.01M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z" stroke="#EE0033" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
  <h2 class="text-center mat-dialog-title" style="color: #101828; font-weight: 700">
    {{'alert.notification' | translate}}
  </h2>
  <button type="button" class="close" style="position: absolute; top: 0; right: 0;" aria-label="Close" (click)="closeDialog()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="row">
  <div class="pl-0" style="text-align: center;">
    <div [innerHTML]="data.message1 | translate" style=" padding-top: 1px; padding-bottom: 20px; color: #667085"></div>
    <!-- <i [innerHTML]="data.message2 | translate" style=" padding-top: 1px; padding-bottom: 20px; color: #667085"></i> -->
  </div>
</div>
<div mat-dialog-actions class="justify-content-center mt-2">
  <button mat-stroked-button color="primary" class="font-weight-bold" type="button" (click)="onNoClick()" cdkFocusInitial>
    {{data.btn1 | translate}}
  </button>
  <button class="ml-2 font-weight-bold" mat-raised-button color="primary" type="button" (click)="handleAccept()">
    {{data.btn2 | translate}}
  </button>
</div>